module.exports = __webpack_public_path__ + "static/media/logout.cb6a3750.svg";